
/*
 *  This file app-routing.module.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './global/guard/auth-guard-service';
import { RedirectToHomeGuardService } from './global/guard/redirect-to-home-guard.service';
import { LogonUserResolverService } from './global/services/logon-user-resolver.service';


const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'app', loadChildren: () => import('./main/main.module').then(m => m.MainModule), canLoad: [AuthGuardService],
    resolve: {
      user: LogonUserResolverService
    }
  },
  {
    path: 'login', loadChildren: () => import('./authentication/login/login.module').then(m => m.LoginModule),
    canLoad: [RedirectToHomeGuardService]
  },
  { path: 'onboarding-config', loadChildren: () => import('./modules/onboarding-config/onboarding-config.module').then(m => m.OnboardingConfigModule) },
  {
    path: 'hroneAuth', loadChildren: () => import('./authentication/saml-auth/saml-auth.module').then(m => m.SamlAuthModule),
    canLoad: [RedirectToHomeGuardService]
  },
  {
    path: 'support',
    loadChildren: () => import('./modules/support/support.module').then(m => m.SupportModule)
  },
  { path: 'google-meet', loadComponent: () => import('./global/components/google-meet-redirect/google-meet-redirect.component').then(m => m.GoogleMeetRedirectComponent) },
  { path: 'esignature', loadComponent: () => import('./global/components/esignature/esignature.component').then(m => m.EsignatureComponent) },
  { path: 'signature-success', loadComponent: () => import('./global/components/esignature-redirect/esignature-redirect.component').then(m => m.EsignatureRedirectComponent) },
  { path: 'signature-error', loadComponent: () => import('./global/components/esignature-redirect/esignature-redirect.component').then(m => m.EsignatureRedirectComponent) },
  { path: 'signature-cancel', loadComponent: () => import('./global/components/esignature-redirect/esignature-redirect.component').then(m => m.EsignatureRedirectComponent) },
  {
    path: 'new-profile',
    loadChildren: () => import('./modules/new-profile-menus/new-profile-menus-routes').then(m => m.NEW_PROFILE_MENUS)
  },
  { path: 'teams-meet', loadComponent: () => import('./global/components/google-meet-redirect/google-meet-redirect.component').then(m => m.GoogleMeetRedirectComponent) },
  {
    path: 'candidate-list-new/:requestId', loadComponent: () => import('src/app/modules/recruitment/candidate/candidateList1/CandidateListNew.component').then(m => m.CandidateListNewComponent),
    resolve: {
      user: LogonUserResolverService
    }
  },
  {
    path: 'candidate-list/:requestId/:employeeId/:transactionId/:isArchived/:tabIndex/:from',
    loadChildren: () => import('./modules/recruitment/candidate/candidate-list/candidate-list.module').then(m => m.CandidateListModule),
    resolve: {
      user: LogonUserResolverService
    }
  },
  { path: '**', loadChildren: () => import('./authentication/not-found/not-found.module').then(m => m.NotFoundModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
